var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#C05B87",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.833 27.583c.645 0 1.167.522 1.167 1.167 0 .598-.45 1.091-1.03 1.159l-.137.007H9.5c-.644 0-1.167-.522-1.167-1.166 0-.599.45-1.092 1.03-1.16l.137-.007h16.333zM30.5 21.75c.644 0 1.167.522 1.167 1.166 0 .599-.45 1.092-1.031 1.16l-.136.007h-21c-.644 0-1.167-.522-1.167-1.167 0-.598.45-1.091 1.03-1.159l.137-.007h21zm-4.667-5.834c.645 0 1.167.523 1.167 1.167 0 .598-.45 1.091-1.03 1.159l-.137.008H9.5c-.644 0-1.167-.523-1.167-1.167 0-.598.45-1.091 1.03-1.159l.137-.008h16.333zm4.667-5.833c.644 0 1.167.522 1.167 1.167 0 .598-.45 1.091-1.031 1.159l-.136.007h-21c-.644 0-1.167-.522-1.167-1.166 0-.599.45-1.092 1.03-1.16l.137-.007h21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderForm);
export default __webpack_public_path__ + "static/media/order-form.33efe40659480e81ead9461b36654c36.svg";
export { ForwardRef as ReactComponent };